module.exports = __webpack_public_path__ + "static/media/image-background-login.2e8796d1.jpg";